var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper__inner--narrow"},[_c('section',{class:_vm.pageCss},[_c('img',{attrs:{"src":_vm.content.image,"alt":_vm.content.alt}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }